<template>
    <div class="vh-100 vw-100 d-flex flex-column">
      <DefaultHeader :noMargin="true"/>
      <CorridoringMap />
    </div>
  </template>
  
  <script>
  import DefaultHeader from '@/components/DefaultHeader.vue'
  import CorridoringMap from './Sections/CorridoringMap.vue'
  
  export default {
      components: {
          DefaultHeader,
          CorridoringMap
      },
      computed: {
          currentUser() {
              return this.$store.state.auth.user
          }
      },
      mounted() {
          if (!this.currentUser) {
              this.$router.push('/')
          }
      }
  }
  </script>